import { render } from "./SpareReplacementModal.vue?vue&type=template&id=1dcbdef8"
import script from "./SpareReplacementModal.vue?vue&type=script&lang=js"
export * from "./SpareReplacementModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__